export default {
  name: 'IconCam',
  props: {
    cam: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      default: 'map' // map | preview - если map вычисляется поворот иконки, позиционировние задается в род. компоенете
    },
    isAlarm: {
      type: Boolean,
      default: false
    },
    isHighlight: {
      type: Boolean,
      default: false
    },
    width: {
      type: Number,
      default: 35
    }
  },
  computed: {
    styleIcon() {
      const res = {}
      if (this.type !== 'preview') {
        res.width = this.width + 'px'
        res.height = this.width + 'px'
      }
      if (this.type === 'map') {
        res.transform = 'rotate(' + this.cam.rotation + 'rad)'
      }
      return res
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/iconCam/iconCam.js